import React from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
const InputFormItem = ({
  name,
  schema,
  hint,
  size,
  password = false,
  placeholder,
  autoFocus,
  autoComplete,
  inputProps,
  errorMessage,
  required = false,
  helpText
}) => {
  const { t } = useTranslation();
  const [field, meta] = useField(name);
  const { label } = schema[name];

  const sizeLabelClassName = {
    small: 'col-form-label-sm',
    large: 'col-form-label-lg',
  }[size] || '';

  const sizeInputClassName = {
    small: 'form-control-sm',
    large: 'form-control-lg',
  }[size] || '';

  const showError = meta.touched && meta.error;

  return (
    <div className="form-group">
      {!!label && (
        <label
          className={`col-form-label ${required ? 'required' : ''} ${sizeLabelClassName}`}
          htmlFor={name}
        >
          {t(label)}
        </label>
      )}
      {!!helpText && <div className="mb-2 ms-4"><small className="form-text text-muted">{t(helpText)}</small></div>}
      <input
        id={name}
        type={password ? 'password' : 'text'}
        {...field}
        placeholder={placeholder || undefined}
        autoFocus={autoFocus || undefined}
        autoComplete={autoComplete || undefined}
        className={`form-control ${sizeInputClassName} ${showError ? 'is-invalid' : ''}`}
        {...inputProps}
      />
      {showError && (
        <div className="invalid-feedback">
          {t(meta.error || errorMessage)}
        </div>
      )}
      {!!hint && <small className="form-text text-muted">{t(hint)}</small>}
    </div>
  );
};


export default InputFormItem;
